// Généré par scripts/generate-flipt-types.js — NE PAS ÉDITER. Relancer : yarn flipt:types
export const FLAGS = {
  BOSupply: 'BO-Supply',
  CAForecasting: 'CA-forecasting',
  Logistique: 'Logistique',
  absenceShift: 'absence-shift',
  adonisQueueInactivateCollaborator: 'adonis-queue-inactivate-collaborator',
  autoClosePreauthOnValidatedCart: 'auto-close-preauth-on-validated-cart',
  automatedInventory: 'automated-inventory',
  boNavbarStoreAppPreview: 'bo-navbar-store-app-preview',
  cardVerification: 'card-verification',
  categoryForecasting31days: 'category-forecasting-31days',
  collabListViewAndImport: 'collab-list-view-and-import',
  comptaExportPanier: 'compta-export-panier',
  configurateurIndustriel: 'configurateur-industriel',
  cpiInventoryEnabledToggle: 'cpi-inventory-enabled-toggle',
  creneauEndsMidnight: 'creneau-ends-midnight',
  dashboardRh: 'dashboard-rh',
  dashboardRhFraisDePerso: 'dashboard-rh-frais-de-perso',
  dashboardRhModalCouverturePlanning: 'dashboard-rh-modal-couverture-planning',
  dashboardRhModalEffectifTotal: 'dashboard-rh-modal-effectif-total',
  dashboardRhModalFpCa: 'dashboard-rh-modal-fp-ca',
  dashboardRhModalSuiviParBoutique: 'dashboard-rh-modal-suivi-par-boutique',
  deletePastWorkShift: 'delete-past-work-shift',
  exportFicheCollab: 'export-fiche-collab',
  featureFlags: 'feature-flags',
  forecastingXiuDashboard: 'forecasting-xiu-dashboard',
  formationHourToDefaultStore: 'formation-hour-to-default-store',
  hrExportAttendanceMultiStore: 'hr-export-attendance-multi-store',
  hrExportPlanningMultiStore: 'hr-export-planning-multi-store',
  logistique: 'logistique',
  mapTilesCompare: 'map-tiles-compare',
  permissionApiKey: 'permission-api-key',
  permissionV2: 'permission-v2',
  permissionV2Administration: 'permission-v2-administration',
  phoneAuth: 'phone-auth',
  planningRemainingHoursMenu: 'planning-remaining-hours-menu',
  planningShiftCreationUpToFourStores: 'planning-shift-creation-up-to-four-stores',
  planningWidgetsAddingPaidTransport: 'planning-widgets-adding-paid-transport',
  previsionsVueLogistique: 'previsions-vue-logistique',
  previsionsVueProduction: 'previsions-vue-production',
  productManagement: 'product-management',
  projectTracking: 'project-tracking',
  rhPersonnelDiscountLinkToAgroDigital: 'rh-personnel-discount-link-to-agro-digital',
  rhPointageDisplayPluriBoutique: 'rh-pointage-display-pluri-boutique',
  rhPointageExportV2: 'rh-pointage-export-v2',
  salesUnitsCorrections: 'sales-units-corrections',
  serviceClientSidebar: 'service-client-sidebar',
  shortTermPrevision: 'short-term-prevision',
  storeAppAddProcessBo: 'store-app-add-process-bo',
  storeAppOperational: 'store-app-operational',
  uvcForecasting52Weeks: 'uvc-forecasting-52-weeks',
  visioReviews: 'visio-reviews',
} as const

export type FlagKey = (typeof FLAGS)[keyof typeof FLAGS]

export interface FliptVariants {
  'BO-Supply': never // flag booléen
  'CA-forecasting': never // flag booléen
  Logistique: never // flag booléen
  'absence-shift': never // flag booléen
  'adonis-queue-inactivate-collaborator': never // flag booléen
  'auto-close-preauth-on-validated-cart': never // flag booléen
  'automated-inventory': never // flag booléen
  'bo-navbar-store-app-preview': never // flag booléen
  'card-verification': never // flag booléen
  'category-forecasting-31days': never // flag booléen
  'collab-list-view-and-import': never // flag booléen
  'compta-export-panier': never // flag booléen
  'configurateur-industriel': never // flag booléen
  'cpi-inventory-enabled-toggle': never // flag booléen
  'creneau-ends-midnight': never // flag booléen
  'dashboard-rh': never // flag booléen
  'dashboard-rh-frais-de-perso': never // flag booléen
  'dashboard-rh-modal-couverture-planning': never // flag booléen
  'dashboard-rh-modal-effectif-total': never // flag booléen
  'dashboard-rh-modal-fp-ca': never // flag booléen
  'dashboard-rh-modal-suivi-par-boutique': never // flag booléen
  'delete-past-work-shift': never // flag booléen
  'export-fiche-collab': never // flag booléen
  'feature-flags': never // flag booléen
  'forecasting-xiu-dashboard': never // flag booléen
  'formation-hour-to-default-store': never // flag booléen
  'hr-export-attendance-multi-store': never // flag booléen
  'hr-export-planning-multi-store': never // flag booléen
  logistique: never // flag booléen
  'map-tiles-compare': never // flag booléen
  'permission-api-key': never // flag booléen
  'permission-v2': never // flag booléen
  'permission-v2-administration': never // flag booléen
  'phone-auth': never // flag booléen
  'planning-remaining-hours-menu': never // flag booléen
  'planning-shift-creation-up-to-four-stores': never // flag booléen
  'planning-widgets-adding-paid-transport': never // flag booléen
  'previsions-vue-logistique': never // flag booléen
  'previsions-vue-production': never // flag booléen
  'product-management': never // flag booléen
  'project-tracking': never // flag booléen
  'rh-personnel-discount-link-to-agro-digital': never // flag booléen
  'rh-pointage-display-pluri-boutique': never // flag booléen
  'rh-pointage-export-v2': never // flag booléen
  'sales-units-corrections': never // flag booléen
  'service-client-sidebar': never // flag booléen
  'short-term-prevision': never // flag booléen
  'store-app-add-process-bo': never // flag booléen
  'store-app-operational': never // flag booléen
  'uvc-forecasting-52-weeks': never // flag booléen
  'visio-reviews': never // flag booléen
}
